import { render, staticRenderFns } from "./shipmentRequest.vue?vue&type=template&id=506b8bb0&scoped=true&"
import script from "./shipmentRequest.vue?vue&type=script&lang=js&"
export * from "./shipmentRequest.vue?vue&type=script&lang=js&"
import style0 from "./shipmentRequest.vue?vue&type=style&index=0&id=506b8bb0&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b8bb0",
  null
  
)

export default component.exports